import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import useTextContents from '../../hooks/useTextContents'
import {ReactComponent as ContractDoneIcon} from '../../icons/svg/contract-done-page-icon.svg'
import { AppState } from '../../store'
import PageScreen from '../../components/organisms/Page/PageScreen'
import Paragraph from '../../components/atoms/Paragraph/Paragraph'
import { APP_COLOR, APP_FONT_SIZE } from '../../components/atoms/AtomsGlobalProps'
import LoanOfferSummaryPanel from '../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel'

import './ContractDonePage.scss'


/**
 * Komponent wyświetlający stronę z wyborem weryfikacji manualnej dla klienta.
 * @returns 
 */
const ContractDonePage = () =>{
   const textContent = useTextContents()
   const contractDoneData = useSelector((state: AppState) => state.applicationState.manualVerificationState.contractDone)


   return (
      <PageScreen 
         title={{title: textContent('contractDonePage.heading'), line: true }} 
         icon={{ icon: ContractDoneIcon, decorative: true, color: 'var(--color-primary-600)' }}
         panel={<LoanOfferSummaryPanel readOnly={true} loanVariant='selectedOffer' />}
      >
         <div className='contract-done-page-description'>
            <Paragraph>
               {textContent('contractDonePage.mainContentTextUp.part_1')} <b>{contractDoneData.clientBankAccountNumber}</b>
            </Paragraph>
            <Paragraph>
               {textContent('contractDonePage.mainContentTextUp.part_2')}
            </Paragraph>
         </div>
         <Paragraph size={APP_FONT_SIZE.SMALL} color={APP_COLOR.GRAY} align='center'>
            {textContent('contractDonePage.tip')}
         </Paragraph>
      </PageScreen>
   )
}

export default ContractDonePage